const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const IframeModal = require('app/ui/modal/IFrame');

const SupplierForm = require('app/supplier/Form');
const SupplierSectorForm = require('app/supplier/info/SectorForm');

class InfoTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'supplier': {'id':null,'name':null},
            'supplierMissingFTBaseUrl': window.App.get('supplierMissingFTBaseUrl'),
            'supplierPricesMistakesBaseUrl': window.App.get('supplierPricesMistakesBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickBtnShowMissingFT = this.onClickBtnShowMissingFT.bind(this);
        this.onClickBtnShowPricesMistakes = this.onClickBtnShowPricesMistakes.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.supplier = this.settings.supplier;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
        this.supplierForm.onDOMReady();
    }

    buildTab(){

        let $btnShowMissingFT = $('<button/>')
        .addClass('btn btn-primary')
        .append(
            $('<i/>')
            .addClass('fas fa-search me-1')
        )
        .append(window.translate('app.supplier.show.tabs.info.missingFT.label'))
        .on("click",this.onClickBtnShowMissingFT)

        let $btnShowPricesMistakes = $('<button/>')
        .addClass('btn btn-primary')
        .append(
            $('<i/>')
            .addClass('fas fa-euro-sign me-1')
        )
        .append(window.translate('app.supplier.show.tabs.info.pricesMistakes.label'))
        .on("click",this.onClickBtnShowPricesMistakes)

        this.$container
        .html('')
        .append(
            $('<div/>')
            .addClass('white-box')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col')
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-center')
                    .append($btnShowMissingFT)
                )
            )
            .append(
                $('<div/>')
                .addClass('col')
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-center')
                    .append($btnShowPricesMistakes)
                )
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.buildInfosForm())
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.buildSectorsForm())
            )
        );

        this.onDOMReady();
    }

    buildInfosForm(){
        var self = this;
        this.supplierForm = new SupplierForm({
            'supplier': this.supplier,
            'success': function(){
                self.supplierForm.refresh();
            }
        });

        return this.supplierForm.getForm();
    }

    buildSectorsForm(){
        var self = this;
        this.sectorForm = new SupplierSectorForm({
            'supplier': this.supplier,
            'success': function(){
                self.sectorForm.refresh();
            }
        });

        return this.sectorForm.getForm();
    }
    onClickBtnShowMissingFT(event){
        event.preventDefault();
        event.stopPropagation();

        let url = this.settings.supplierMissingFTBaseUrl.replace('__ID__',this.supplier.id);


        let modal = new IframeModal({
            'url': url
        });
        modal.show();
    }
    onClickBtnShowPricesMistakes(event){
        event.preventDefault();
        event.stopPropagation();

        let url = this.settings.supplierPricesMistakesBaseUrl.replace('__ID__',this.supplier.id);


        let modal = new IframeModal({
            'url': url
        });
        modal.show();
    }
}

module.exports = InfoTab;

